
import React, { useState, useEffect } from "react";

import JobCard from "./JobCard.js";
import JobDetailsModal from "./JobDetailsModal";
import ApplyModal from "./ApplyModal";





const features = [
    {
        title: "Growth-Driven Culture",
        desc: "Clear career paths, regular feedback, and performance-based growth opportunities.",
    },
    {
        title: "Learning and Skill Development",
        desc: "Access to training, upskilling programs, and continuous professional  development.",
    },
    {
        title: " Diverse Career Opportunities ",
        desc: "Work across multiple companies, teams, and industries within one group.",
    },
    {
        title: "Work-Life Balance",
        desc: "Flexible work culture focused on productivity, balance, and employee wellbeing.",
    },
    {
        title: "Innovation First",
        desc: "Encouragement to bring new ideas and solutions.",
    },
];

const steps = [
    {
        step: "1",
        title: "Apply Online",
        desc: "Submit Your Application",
        icon: "bi-file-earmark-text",
    },
    {
        step: "2",
        title: "HR Screening",
        desc: "Profile Review",
        icon: "bi-people",
    },
    {
        step: "3",
        title: "Interview",
        desc: "Team Assessment",
        icon: "bi-chat-dots",
    },
    {
        step: "4",
        title: "Offer Letter",
        desc: "Welcome Aboard!",
        icon: "bi-award",
    },
];

const faqs = [
    {
        question: "Can I Apply To Multiple Roles At Visko Group?",
        answer:
            "Yes, you can apply for multiple roles that match your skills and experience. However, we recommend focusing on positions that best align with your background.",
    },

    {
        question: "Do You Offer Remote Work Opportunities?",
        answer:
            "Yes, select positions offer remote or hybrid work options. The work arrangement is mentioned in each job posting. Please check the job details for specific information.",
    },
    {
        question: "Are Freshers Welcome To Apply?",
        answer:
            "Yes, freshers are welcome to apply for entry-level roles and internship opportunities depending on the position requirements.",
    },
    {
        question: "What Documents Do I Need To Apply?",
        answer:
            "Typically, you will need an updated resume and relevant supporting documents. Some roles may require a portfolio or certifications.",
    },
    {
        question: "Will I Be Charged Any Fees During The Hiring Process?",
        answer:
            "No, Visko Group does not charge any fees at any stage of the hiring process.",
    },
];
const Career = () => {

    const [jobList, setJobList] = useState([]);
    const [activeCompany, setActiveCompany] = useState(null);
    const [selectedJob, setSelectedJob] = useState(null);
    const [showDetails, setShowDetails] = useState(false);
    const [showApply, setShowApply] = useState(false);
    const [companies, setCompanies] = useState([]);
    const [loading, setLoading] = useState(true);


    useEffect(() => {
        fetch("https://api.visko.group/api/crm/career/fetch-all-comapny")
            .then((res) => res.json())
            .then((data) => {
                console.log(data, 333);

                const companyList = data?.data || [];
                setCompanies(companyList);


                if (companyList.length > 0) {
                    setActiveCompany(companyList[0]);
                    fetchCompaniesJobs(companyList[0]);
                }

                setLoading(false);
            })
            .catch((error) => {
                console.error("Career API Error:", error);
                setLoading(false);
            });
    }, []);




    const fetchCompaniesJobs = (company) => {

        setActiveCompany(company);

        fetch(`https://api.visko.group/api/crm/career/fetch-all-career?c_company_id=${company.c_id}`)
            .then((res) => res.json())
            .then((data) => {
                console.log(data, 444);

                setJobList(data?.data || []);

                setLoading(false);
            })
            .catch((error) => {
                console.error("Career API Error:", error);
                setLoading(false);
            });
    };



    if (loading) {
        return <p className="text-center mt-5">Loading careers...</p>;
    }
    return (
        <>
            <section
                className="career-hero d-flex align-items-center text-center text-white position-relative"
                style={{
                    backgroundImage:
                        "url(https://api.visko.group/public/assets/img/uploads/ticket-docs/1767345653_7d22fee913a557135371.png)",
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    backgroundRepeat: "no-repeat",
                    minHeight: "100vh",
                    width: "100%",
                }}
            >
                <div className="overlay position-absolute top-0 start-0 w-100 h-100"></div>

                <div className="container position-relative px-3">
                    <span className="badge rounded-pill py-2 px-4 fs-6 fw-normal btn btn-outline-secondary">
                        We’re hiring across 4 companies
                    </span>

                    <h1 className="fw-bold mt-4 text-white display-4 display-md-3 display-lg-2">
                        Build a Career Across Multiple
                        <br className="d-none d-md-block" /> Industries
                    </h1>

                    <p className="lead mt-3 fw-normal">

                        Opportunities across 4 companies spanning multiple industries and career domains


                    </p>

                    {/* <div className="d-flex justify-content-center gap-3 mt-4 flex-wrap">
                        <button className="btn px-4 py-2 fw-semibold" style={{ backgroundColor: "#ff6a2a", color: "white" }}>
                            Explore
                        </button>
                        <button className="btn px-4 py-2 fw-semibold" style={{ backgroundColor: "white", color: "black" }}>
                            Contact
                        </button>
                    </div> */}

                    <div className="d-flex justify-content-center gap-3 gap-md-4 mt-5 fs-6 flex-wrap">
                        <span>Trusted by 2,000+ candidates</span>
                        <span className="d-none d-md-inline">•</span>
                        <span>Hiring across India</span>
                        <span className="d-none d-md-inline">•</span>
                        <span>Since 2021</span>
                    </div>
                </div>
            </section>


            <div className="container py-4 py-lg-5">
                <h2 className="text-center fw-bold fs-2 fs-lg-1">
                    Open Career Opportunities
                </h2>

                <p className="text-center text-muted mb-4 mb-lg-5 fs-6 fs-lg-5">
                    Opportunities across multiple companies and domains
                </p>

                <div className="row g-4">
                    {/* Sidebar */}
                    <div className="col-12 col-lg-4">
                        <div className="card shadow-sm border-1  h-100">
                            <div className="card-body p-3 p-lg-4">

                                {/* Header */}
                                <h5 className="fw-bold mb-3 text-dark d-flex align-items-center justify-content-center justify-content-lg-start">
                                    <img
                                        src="https://api.visko.group/public/assets/img/uploads/ticket-docs/1767351911_6e5aae9fb2e481beaaeb.png"
                                        alt="Visko Logo"
                                        className="me-2 rounded"
                                        style={{ width: "38px", height: "38px" }}
                                    />
                                    Visko Group
                                </h5>

                                {/* Companies list */}
                                <div
                                    className="d-flex d-lg-block gap-2 flex-nowrap py-4 flex-lg-column overflow-auto"
                                    style={{ maxHeight: "420px" }}
                                >
                                    {companies?.map((company) => (
                                        <div
                                            key={company.c_id}
                                            onClick={() => fetchCompaniesJobs(company)}
                                            className={`
                            px-3 py-2
                            rounded
                            text-nowrap
                            cursor-pointer
                            border
                            fs-6
                            d-flex align-items-center
                            justify-content-center justify-content-lg-start
                            ${activeCompany === company
                                                    ? "fw-bold bg-light border-secondary"
                                                    : "bg-white border-light"}
                        `}
                                            onMouseEnter={(e) => e.currentTarget.classList.add("fw-bold")}
                                            onMouseLeave={(e) =>
                                                activeCompany !== company &&
                                                e.currentTarget.classList.remove("fw-bold")
                                            }
                                        >
                                            {company.c_name}
                                        </div>
                                    ))}
                                </div>

                            </div>
                        </div>
                    </div>

                    {/* Jobs */}
                    <div className="col-12 col-lg-8">
                        <div
                            className="job-scroll"
                            style={{
                                maxHeight: "520px",
                                overflowY: "auto",
                            }}
                        >
                            {jobList?.map((job, index) => (
                                <JobCard
                                    key={job.id}
                                    job={job}
                                    onView={() => {
                                        setSelectedJob(job);
                                        setShowDetails(true);
                                    }}
                                    onApply={() => {
                                        setSelectedJob(job);
                                        setShowApply(true);
                                    }}
                                    hidden={index >= 2}
                                />
                            ))}
                        </div>
                    </div>
                </div>

                {/* Modals */}
                <JobDetailsModal
                    show={showDetails}
                    onClose={() => setShowDetails(false)}
                    job={selectedJob}
                    onApply={() => {
                        setShowDetails(false);
                        setShowApply(true);
                    }}
                />

                <ApplyModal
                    show={showApply}
                    onClose={() => setShowApply(false)}
                    job={selectedJob}
                />
            </div>


            <section className="py-5 bg-white">
                <div className="container">
                    {/* Heading */}
                    <div className="text-center mb-5">
                        <h2 className="fw-bold fs-2 fs-lg-1">Why Work At Visko?</h2>
                        <p className="text-muted fs-5 mt-2">
                            Build your career with a growing organization that values skills, performance, and long-term growth.

                        </p>
                    </div>

                    {/* Cards */}
                    <div className="row g-4 justify-content-center">
                        {features.map((item, index) => (
                            <div
                                key={index}
                                className="col-12 col-sm-6 col-lg-4 d-flex"
                            >
                                <div className=" card   w-100   text-start p-3  border border-secondary-subtle rounded-3 ">

                                    <h5 className="fw-bold fs-5 mb-2">
                                        {item.title}
                                    </h5>
                                    <p className="text-muted mb-0">
                                        {item.desc}
                                    </p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>


            <section className="py-5 bg-white">
                <div className="container">
                    {/* Heading */}
                    <div className="text-center mb-5">
                        <h2 className="fw-bold fs-2 fs-md-1">Our Hiring Process</h2>
                        <p className="text-muted fs-5  mt-2">
                            A simple and transparent process to help you join our team
                        </p>
                    </div>

                    {/* Timeline */}
                    <div className="row justify-content-center position-relative">
                        {/* Line (Desktop only) */}
                        <div className="d-none d-lg-block position-absolute top-50 start-0 end-0 mx-auto"
                            style={{ height: "1px", background: "#ddd", width: "75%" }}>
                        </div>

                        {steps.map((item, index) => (
                            <div
                                key={index}
                                className="col-12 col-md-6 col-lg-3 text-center mb-4 position-relative"
                            >
                                {/* Step Number */}
                                <span
                                    className="position-absolute top-0 start-50 translate-middle badge rounded-pill bg-dark"
                                    style={{ zIndex: 2 }}
                                >
                                    {item.step}
                                </span>

                                {/* Icon Box */}
                                <div className="card border-0 shadow-sm rounded-4 mx-auto p-3"
                                    style={{ width: "80px", height: "80px" }}>
                                    <i className={`bi ${item.icon} fs-3 m-auto`}></i>
                                </div>

                                {/* Text */}
                                <h6 className="fw-bold mt-4">{item.title}</h6>
                                <p className="text-muted small">{item.desc}</p>
                            </div>
                        ))}
                    </div>

                    {/* Timeline Info */}
                    <div className="mt-4">
                        <div className="alert alert-primary border text-center rounded-4 ">
                            <strong className="text-dark">Timeline:</strong>{" "}
                            <span className="text-secondary">
                                Our typical hiring process takes 1–2 weeks from application to offer letter
                            </span>
                        </div>
                    </div>
                </div>
            </section>


            <section className="py-5 bg-white">
                <div className="container">
                    {/* Heading */}
                    <div className="text-center mb-5">
                        <h2 className="fw-bold fs-1">Frequently Asked Questions</h2>
                        <p className="text-muted fs-5">Got questions? We've got answers</p>
                    </div>

                    {/* Accordion */}
                    <div className="row justify-content-center">
                        <div className="col-12 col-lg-8">
                            <div className="accordion" id="faqAccordion">
                                {faqs.map((item, index) => (
                                    <div
                                        className="accordion-item mb-3 border rounded-5"
                                        key={index}
                                    >
                                        <h2 className="accordion-header">
                                            <button
                                                className={`accordion-button ${index !== 2 ? "collapsed" : ""
                                                    } fw-bold`}
                                                type="button"
                                                data-bs-toggle="collapse"
                                                data-bs-target={`#faq-${index}`}
                                            >
                                                {item.question}
                                            </button>
                                        </h2>
                                        <div
                                            id={`faq-${index}`}
                                            className={`accordion-collapse collapse ${index === 2 ? "show" : ""
                                                }`}
                                            data-bs-parent="#faqAccordion"
                                        >
                                            <div className="accordion-body text-muted">
                                                {item.answer}
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            <section
                className="career-cta text-white py-5"
                style={{ backgroundColor: "#121213ff" }}
            >
                <div className="container text-center">
                    {/* Heading */}
                    <h2 className="fw-bold text-white mb-3">Didn't Find A Suitable Role?</h2>
                    <p className="text-white  opacity-75 mb-4">
                        We're always looking for talented individuals. Send us your CV and
                        we'll keep you in mind for future opportunities.
                    </p>

                    {/* Email Button */}
                    <a
                        href="mailto:careers@viskogroup.com"
                        className="btn btn-light px-4 py-2 fw-semibold d-inline-flex align-items-center gap-2"
                    >
                        <i className="bi bi-envelope"></i>
                        hr@visko.group
                    </a>

                    {/* Divider */}
                    <hr className="my-5 border-light opacity-25" />

                    {/* Trust Badges */}
                    <div className="row justify-content-center gy-3">
                        <div className="col-12 col-md-4">
                            <div className="d-flex align-items-center justify-content-center gap-2">
                                <i className="bi bi-shield-check text-warning fs-5"></i>
                                <span>Official Visko Group Careers</span>
                            </div>
                        </div>

                        <div className="col-12 col-md-4">
                            <div className="d-flex align-items-center justify-content-center gap-2">
                                <i className="bi bi-shield-lock text-warning fs-5"></i>
                                <span>We Never Charge For Jobs</span>
                            </div>
                        </div>

                        <div className="col-12 col-md-4">
                            <div className="d-flex align-items-center justify-content-center gap-2">
                                <i className="bi bi-shield-shaded text-warning fs-5"></i>
                                <span>Your Data Is Protected</span>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default Career

